<template>
  <div>
    <el-form :model="form" ref="form" label-width="70px" :inline="false" size="small">
      <el-form-item label="昵称" prop="name" :rules="rules">
        <el-input v-model.trim="form.name" placeholder="请填写会员昵称"></el-input>
      </el-form-item>
      <el-form-item label="账号" prop="account" :rules="rules">
        <el-input v-model.trim="form.account" placeholder="请填写会员账号"></el-input>
      </el-form-item>
      <el-form-item label="密码">
        <el-input placeholder="初始密码为123，请会员首次登录后自行更改" disabled></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit('form')">立即添加</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  data () {
    return {
      form: {
        name: '',
        account: ''
      },
      rules: { required: true, message: '必填项，不能为空', trigger: 'blur' }
    }
  },
  methods: {
    onSubmit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.handleCreate(formName)
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    handleCreate (formName) {
      const that = this
      that.axios.post('admin/member', that.form).then(function (resp) {
        if (resp.data.code === 0) {
          that.$message.success('添加成功')
          that.$refs[formName].resetFields()
          that.$emit('success')
        }
        if (resp.data.code === 1) {
          that.$message.error(resp.data.msg)
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
